import { PropsWithChildren, ReactNode } from "react";

import _ from "lodash";

import { Badge, BadgeProps, Grid, GridItem, HStack, Text, Tooltip, VStack } from "@chakra-ui/react";

import BadgeSpinner from "@/components/shared/BadgeSpinner";
import StateBadgeDot from "@/components/StateBadges/StateBadgeDot";

import resourceTooltips from "./resourceTooltips";

type StateBadgeProps = {
  state: string;
  spinnerVisibleOnStates?: string[];
  label?: string;
  resource?: keyof typeof resourceTooltips;
  badgeDot?: ReactNode;
} & BadgeProps;
function StateBadge({
  state = "",
  spinnerVisibleOnStates = [],
  label,
  resource,
  badgeDot,
  children,
  ...props
}: PropsWithChildren<StateBadgeProps>) {
  let tooltip;
  if (resource) {
    tooltip = resourceTooltips[resource]?.[state.toLowerCase()];
  }

  return (
    <Tooltip hasArrow isDisabled={!tooltip} label={tooltip} placement="top-start">
      <Badge backgroundColor="background.darker" h="min-content" {...props}>
        <VStack spacing={1}>
          <Grid alignItems="center" templateColumns="auto 1fr" w="100%">
            <GridItem>{badgeDot ?? <StateBadgeDot state={state} />}</GridItem>
            <GridItem textAlign="center">
              <HStack spacing={0}>
                <Text flex={1} fontSize={{ base: "2xs", md: "xs" }}>
                  {_.startCase((label ?? state).toLowerCase())}
                </Text>{" "}
                <BadgeSpinner inputState={state} visibleOnStates={spinnerVisibleOnStates} />
              </HStack>
            </GridItem>
          </Grid>
          {children}
        </VStack>
      </Badge>
    </Tooltip>
  );
}

export default StateBadge;
